import { gql } from '@apollo/client';

export const listCourses = gql`
  query ListCourses($filter: CourseFilter, $pagination: PaginationInput) {
    listCourses(filter: $filter, pagination: $pagination) {
      id
      shortId
      domains {
        name
      }
      name {
        value
        languageCode
      }
      createdAt
      categories {
        id
        name {
          value
          languageCode
        }
      }
      experts {
        id
        firstName
        lastName
      }
      type
      status
      archivedScheduledAt
      archiveDate
      publishedAt
      catalogs {
        id
        name {
          value
          languageCode
        }
      }
    }
  }
`;

export const listFeaturedCourses = gql`
  query ListFeaturedCourses {
    listFeaturedCourses {
      id
      name {
        languageCode
        value
      }
    }
  }
`;
